import { isEmpty } from "lodash";
import {
  GetCustomerContractProfile,
  useRemoveCustomerContractPriceListMutation
} from "@graphql";
import { useArrayState, useConfirmDialog, useSnackbars } from "@hooks";
import { OkCancelDialogOptions } from "@containers";

export function useRemovePriceList() {
  const removingIds = useArrayState<string>([]);
  const [removePriceList] = useRemoveCustomerContractPriceListMutation();
  const { confirm } = useConfirmDialog();
  const { showError, showSuccess } = useSnackbars();

  const _remove = (id: string) => {
    if (removingIds.includes(id)) {
      return;
    }

    removingIds.push(id);

    removePriceList({
      variables: { priceListId: id },
      refetchQueries: [GetCustomerContractProfile.OperationName]
    })
      .then((result) => {
        if (isEmpty(result.errors)) {
          showSuccess(`Done`);
        } else {
          showError(`Cannot remove pricelist\nReason: ${result.errors.join("\n")}`);
        }
      })
      .catch((err) => {
        showError(`cannot remove pricelist`);
      })
      .finally(() => {
        removingIds.remove((x) => x === id);
      });
  };

  const remove = (id: string) => {
    confirm(new OkCancelDialogOptions()).then((response) => {
      if (response !== "ok") {
        return;
      }

      return _remove(id);
    });
  };

  return { remove, removingIds };
}
